import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type AgentOnboardingTimeSinkId } from './agentOnboardingAnalytics';
import META from './useTrackAgentOnboardingOutcomeSelected.meta';
import { withWorkspaceAgentCategory } from './workspaceAgentAnalytics';

export type UseTrackAgentOnboardingOutcomeSelectedParams = {
  outcome: AgentOnboardingTimeSinkId;
  resolved_preview_id: AgentOnboardingTimeSinkId;
};

export const useTrackAgentOnboardingOutcomeSelected = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentOnboardingOutcomeSelected = useCallback(
    (params: UseTrackAgentOnboardingOutcomeSelectedParams) => {
      track(META.name, withWorkspaceAgentCategory(params));
    },
    [track],
  );

  return { trackAgentOnboardingOutcomeSelected };
};
